/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Paper from "@mui/material/Paper";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import Grid from "@mui/material/Grid";
import FormSubmit from "@/src/components/Form/Common/FormSubmit/FormSubmit";
import { useForm } from "@/src/provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import NumberFieldConfigured from "@/src/components/Form/ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import FormSubmitProps from "@/src/types/FormSubmitProps";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box } from "@mui/material";

type FinanceProps = {
  submitProps: FormSubmitProps;
};
export default function Finance({ submitProps }: FinanceProps) {
  const { handleSubmit, values } = useForm();
  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Finanzen
          </Typography>
          <Typography variant={"h4"} sx={wizardStyle.subheadline}>
            Nettoeinkommen
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid sx={wizardStyle.gridTopSpaced} size={12}>
              <FormLegend>
                Wie viel verdienen Sie und Ihr Expartner netto pro Monat? Anhand dieser Angaben können Sie frühzeitig erfahren, welche Kosten bei einer
                Scheidung auf Sie zukämen. Das Gericht ermittelt später anhand der Einkommen den Verfahrenswert der Scheidung und setzt so die Kosten fest.
              </FormLegend>
            </Grid>
            <NumberFieldConfigured caseData={values} fieldPath={"netIncomePetitioner"} fieldType={"money"} required={true} />
            <NumberFieldConfigured caseData={values} fieldPath={"netIncomePartner"} fieldType={"money"} required={true} />
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
